export function getView(value) {
  switch (value) {
    case 'priority':
      return 'Priority'

    case 'tag':
      return 'Tag'

    default:
      return 'TextDisplay'
  }
}
